export const initState = {
	render: 'board', // board, edit, add
	id: '',
	board: {
		from: 1,
		size: 10,
		total: 0,
		$list: [],
		_list: 'init',
		deleteModal: false,
		_deleteModal: 'init',
	},
	add: {
		_status: 'init',
		activeFrom: null,
		activeTo: null,
		isVisible: { name: 'منتشر شده', type: 'Y' },
		content: '',
		title: '',
		image: '',
		imageType: '',
	},
	edit: {
		_status: '',
		activeFrom: '',
		activeTo: '',
		isVisible: { name: 'منتشر شده', type: 'Y' },
		content: '',
		title: '',
		image: '',
		imageType: '',
	},
};

export default initState;
